import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import {
  createRiskHeatMapData,
  getHeatMapCellColor,
} from "../../lib/riskAnalytics";

const RiskHeatMap = ({
  risks,
  severities,
  likelihoods,
  title = "Risk Heat Map",
  className,
}) => {
  const heatMapData = createRiskHeatMapData(risks, severities, likelihoods);

  if (heatMapData.totalRisks === 0) {
    return (
      <Card className={className}>
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-center py-8">
            <p className="text-muted-foreground">
              No risks available to display heat map
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {/* Heat Map Grid */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="w-16"></th>
                {heatMapData.severityValues.map((severity) => (
                  <th
                    key={severity}
                    className="p-2 text-xs font-medium text-center min-w-[80px]"
                  >
                    {heatMapData.severityLabels[severity] ||
                      `Level ${severity}`}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {/* Reverse likelihood values to show high likelihood at top */}
              {[...heatMapData.likelihoodValues].reverse().map((likelihood) => (
                <tr key={likelihood}>
                  <td className="p-2 text-xs font-medium text-muted-foreground text-right w-16">
                    {heatMapData.likelihoodLabels[likelihood] ||
                      `Level ${likelihood}`}
                  </td>
                  {heatMapData.severityValues.map((severity) => {
                    const count =
                      heatMapData.matrix[`${severity}-${likelihood}`] || 0;
                    const colorClass = getHeatMapCellColor(
                      severity,
                      likelihood,
                      severities,
                      likelihoods,
                      count
                    );

                    return (
                      <td key={`${severity}-${likelihood}`} className="p-1">
                        <div
                          className={`
                            h-12 w-full flex items-center justify-center 
                            rounded border text-sm font-medium
                            ${colorClass}
                          `}
                        >
                          {count}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

export default RiskHeatMap;
